import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
class StatusIndicatorComponent {
  constructor() {
    this.color = '';
    this.disabled = false;
  }
  static {
    this.ɵfac = function StatusIndicatorComponent_Factory(t) {
      return new (t || StatusIndicatorComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StatusIndicatorComponent,
      selectors: [["sol-status-indicator"]],
      inputs: {
        status: "status",
        color: "color",
        disabled: "disabled"
      },
      decls: 3,
      vars: 5,
      consts: [[1, "sol-status-indicator"], ["width", "10", "height", "10", "viewBox", "0 0 10 10", "xmlns", "http://www.w3.org/2000/svg"], ["cx", "5", "cy", "5", "r", "4.5"]],
      template: function StatusIndicatorComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(1, "svg", 1);
          i0.ɵɵelement(2, "circle", 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵclassMap(ctx.status);
          i0.ɵɵclassProp("disabled", ctx.disabled);
          i0.ɵɵattribute("fill", ctx.color);
        }
      },
      styles: [".sol-status-indicator[_ngcontent-%COMP%]{display:inline-flex}.sol-status-indicator[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{stroke:var(--color-interface-text800)}.sol-status-indicator[_ngcontent-%COMP%]   svg.success[_ngcontent-%COMP%]{fill:var(--color-interface-success200)}.sol-status-indicator[_ngcontent-%COMP%]   svg.warning[_ngcontent-%COMP%]{fill:var(--color-interface-warning100)}.sol-status-indicator[_ngcontent-%COMP%]   svg.error[_ngcontent-%COMP%]{fill:var(--color-button-destructive-normal)}.sol-status-indicator[_ngcontent-%COMP%]   svg.info[_ngcontent-%COMP%]{fill:var(--color-interface-info350)}.sol-status-indicator[_ngcontent-%COMP%]   svg.disabled[_ngcontent-%COMP%]{fill:var(--color-globalstate-disabled-content);stroke:var(--color-globalstate-disabled-content)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StatusIndicatorComponent, [{
    type: Component,
    args: [{
      selector: 'sol-status-indicator',
      template: `
    <span class="sol-status-indicator">
      <svg
        [class]="status"
        [class.disabled]="disabled"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        [attr.fill]="color"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="5" cy="5" r="4.5" />
      </svg>
    </span>
  `,
      styles: [".sol-status-indicator{display:inline-flex}.sol-status-indicator svg{stroke:var(--color-interface-text800)}.sol-status-indicator svg.success{fill:var(--color-interface-success200)}.sol-status-indicator svg.warning{fill:var(--color-interface-warning100)}.sol-status-indicator svg.error{fill:var(--color-button-destructive-normal)}.sol-status-indicator svg.info{fill:var(--color-interface-info350)}.sol-status-indicator svg.disabled{fill:var(--color-globalstate-disabled-content);stroke:var(--color-globalstate-disabled-content)}\n"]
    }]
  }], null, {
    status: [{
      type: Input
    }],
    color: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }]
  });
})();
class StatusIndicatorModule {
  static {
    this.ɵfac = function StatusIndicatorModule_Factory(t) {
      return new (t || StatusIndicatorModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StatusIndicatorModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StatusIndicatorModule, [{
    type: NgModule,
    args: [{
      declarations: [StatusIndicatorComponent],
      imports: [],
      exports: [StatusIndicatorComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of toggle-group
 */

/**
 * Generated bundle index. Do not edit.
 */

export { StatusIndicatorComponent, StatusIndicatorModule };
